import Vue from 'vue';

// 使用 Event Bus
var bus = new Vue();
export default bus;